export default {"src":"/_next/static/media/core-features.739e0669.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};